import React, {useMemo} from 'react';
import {useSelector} from 'react-redux';
import styled from 'styled-components';
import {useWindowSize} from 'react-use';
import CatalogAlbumDetailHeader from './CatalogAlbumDetailHeader';
import {scrollBar} from '../../styles/sc-mixins';
import Loader from '../../components/Loader';
import CatalogTracks from './CatalogTracks';

const StyledSection = styled.section`
   ${scrollBar()};
`;

const CatalogPlaylistDetail = () => {
	const {height: windowHeight} = useWindowSize();
	const {playlistInfo, tracks, isLoading} = useSelector((state) => state.catalog);

	const heightAdjustment = useMemo(() => {
		if (windowHeight < 720) {
			return +300; 
		} else if (windowHeight < 900) {
			return +200;
		} else if (windowHeight < 1080) {
			return +100;
		} else if (windowHeight <= 1440) {
			return -400;
		} 
	}, [windowHeight]);

	const baseHeight = windowHeight;
	
	const tracksHeight = baseHeight + heightAdjustment;
	return (
		<StyledSection className="card__detailed-content">
			{isLoading
				? <Loader/>
				: (
					<>
						<CatalogAlbumDetailHeader albumInfo={playlistInfo} hideSort/>
						<CatalogTracks height={tracksHeight}/>
					</>
				)
			}
		</StyledSection>
	);
};

export default CatalogPlaylistDetail;
